// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-policies',
    templateUrl: './policies.component.html'
})
export class PoliciesComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}



// WEBPACK FOOTER //
// ./src/app/access-management/policies/policies.component.ts